import { FhsAxios } from "../../services/axios";

export default {
  state: {
    registrationErrors: {},
    registrationCountryList: [],
    currentStep: 1,
    registrationDocumentTypesList: []
  },
  actions: {
    // Функция для базовой регистрации пользователя
    register({ getters, commit }, payload) {
      commit("setRegistrationErrors", {});
      return new Promise(function(resolve) {
        let data = payload.is_legal
          ? {
              bin: payload.bin,
              company_name: payload.company_name,
              phone: payload.phone,
              email: payload.email,
              is_legal: payload.is_legal
            }
          : {
              iin: payload.iin,
              firstname: payload.firstName,
              lastname: payload.lastName,
              patronym: payload.patronymic,
              phone: payload.phoneNumber,
              email: payload.email,
              is_legal: payload.is_legal
            };

        FhsAxios.post("user/register", data).then(response => {
          let result = response.data.result;
          commit("setRegistrationErrors", result.errors);
          if (result === true && !result.errors) {
            resolve(response);
          } else {
            resolve(response);
          }
        });
      });
    },
    fetchUserIncomeSources({ _ }) {
      let url = `utilities/get-income-sources`;
      return FhsAxios.get(url, {
        data: {}
      });
    },
    fetchCountryList({ _, commit }) {
      FhsAxios.get("country/list", {
        data: {}
      }).then(response => {
        let countryList = response.data.result.countries;
        commit("setCountryList", countryList);
      });
    },
    fetchDocumentTypesList({ getters, commit }) {
      FhsAxios.get(`document-types/list`, {
        data: {}
      }).then(response => {
        let documentTypesList = response.data.result.types;
        commit("setDocumentTypesList", documentTypesList);
      });
    }
  },
  mutations: {
    setRegistrationErrors(state, errors) {
      state.registrationErrors = errors;
    },
    setRegistrationStep(state, step) {
      state.currentStep = step;
    },
    setCountryList(state, list) {
      state.registrationCountryList = list;
      let formattedList = [];
      list.map(function(value) {
        formattedList.push({
          value: value.id,
          text: value.name,
          code: value.alfa_code
        });
      });
      state.registrationCountryList = formattedList;
    },
    setDocumentTypesList(state, list) {
      let formattedList = [];
      list.map(function(value) {
        formattedList.push({
          value: value.DOC_TYPE_ID,
          text: value.NAME_DOC,
          code: value.DOC_CODE || null
        });
      });
      state.registrationDocumentTypesList = formattedList;
    }
  },
  getters: {
    registrationErrors(state) {
      return state.registrationErrors;
    },
    registrationCountryList(state) {
      return state.registrationCountryList;
    },
    currentRegistrationStep(state) {
      return state.currentStep;
    },
    registrationDocumentTypesList(state) {
      return state.registrationDocumentTypesList;
    }
  }
};
